import React, { useEffect, useState } from "react";
import Header from "../../components/appLayout/header";
import ProductSection from "../../components/detailsProduct/ProductSection";
import UtilisationSection from "../../components/detailsProduct/UtilisationSection";
import CommentsSection from "../../components/detailsProduct/CommentsSection";
import { ProduitAssocie } from "../../components/detailsProduct/produitAssocie";
import { useParams } from "react-router-dom";
import ProductService from "../../services/product";
import { showErrorToaster } from "../../adminCompenents/listComponents/UI/toaster/error";

const productService = new ProductService();
export const DetailsProduct = () => {
  const { id } = useParams();
  const [product, setProduct] = useState();
  const loadProduct = async () => {
    try {
      const res = await productService.getProductById(id);
      setProduct(res.data);
    } catch (error) {
      showErrorToaster("Erreur lors du chargement des catégories");
    }
  };
  useEffect(() => {
    loadProduct();
  }, [id]);
  console.log("product", product);
  return (
    <div>
      <div className="p-md-5 p-0 pt-md-3">
        {" "}
        <Header />
      </div>

      <ProductSection product={product} />
      <UtilisationSection product={product} id={id} />
      <CommentsSection />
      <ProduitAssocie products={product?.produitsAssocies || []} />
    </div>
  );
};
